import React from 'react';
import PropTypes from 'prop-types';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { GroupFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import { FieldLabel } from 'web-ui-components/lib/typography/labels';

import AddPayeeForm from './AddPayeeForm';

import { copAccountTypes } from '../../../config';
import withValidation from '../../../containers/withValidation';

export const COPType = ({ updateAddPayeeForm, copType, errorMessage, showValidation, propId: id, isEditPayee }) => {
	const businessOption = [{ id: copAccountTypes.Business, labelText: 'Pay a business' }];
	const personOption = [{ id: copAccountTypes.Personal, labelText: 'Pay a person' }];

	const form = (copType) => (
		<ConditionalPanel isVisible>
			<AddPayeeForm id={id} isBusiness={copType === copAccountTypes.Business} />
		</ConditionalPanel>
	);
	const onChangeHandler = (id) => {
		if (!isEditPayee) {
			updateAddPayeeForm({
				name: '',
				sortCode: '',
				accountNumber: '',
				reference: '',
				displayName: '',
				copType: id,
			});
		} else {
			updateAddPayeeForm({
				copType: id,
			});
		}
	};

	return (
		<GroupFieldWrapper>
			{showValidation && (
				<GenericFieldWrapper
					name="field-payment-frequency"
					hasError={showValidation}
					validationMessage={errorMessage}
					description={''}
				/>
			)}
			{isEditPayee && (
				<FieldLabel>
					<GenericRadio.InlineSet
						groupName="radio-group-a"
						items={[...personOption, ...businessOption]}
						onChange={(id) => onChangeHandler(id)}
						selectedId={copType}
					/>
				</FieldLabel>
			)}
			{!isEditPayee && (
				<GroupFieldWrapper
					style={{
						marginTop: '0px',
					}}
				>
					<GenericRadio.InlineSet
						groupName="radio-group-a"
						items={[...personOption, ...businessOption]}
						onChange={(id) => onChangeHandler(id)}
						selectedId={copType}
					/>
					{copType === copAccountTypes.Personal && form(copType)}
					{copType === copAccountTypes.Business && form(copType)}
				</GroupFieldWrapper>
			)}
		</GroupFieldWrapper>
	);
};

COPType.propTypes = {
	onPersonClicked: PropTypes.func,
	onBusinessClicked: PropTypes.func,
	copType: PropTypes.string,
	errorMessage: PropTypes.string,
	isValid: PropTypes.bool,
	showValidation: PropTypes.bool,
};

export default withValidation({
	validations: ['required'],
	key: 'copType',
	message: 'Please select Person or Business',
})(COPType);
